const COSTCENTERS_TABLE_READY = "costCenters-table-ready"
const SEARCH_TEXT_STATE = "costCenters-table-search-text-state"
const ROWS_PER_PAGE_STATE = "costCenters-table-rows-per-page-state"
const PAGINATION_STATE = "costCenters-table-pagination-state"

const COSTCENTERS_ID_FOR_ACTION = "costCenters-table-brand-id-for-action"


const ADDEDIT_COSTCENTERS_READY = "costCenters-table-addedit-costCenters-ready"

const initialState = {
    isCostCentersTableReady: true,
    isAddEditCostCentersReady: true,
    costCenters: {},

    
    costCentersSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case COSTCENTERS_TABLE_READY:
            return Object.assign({}, state, { isCostCentersTableReady: action.payload })

        case ADDEDIT_COSTCENTERS_READY:
            return Object.assign({}, state, { isAddEditCostCentersReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case COSTCENTERS_ID_FOR_ACTION:
            return Object.assign({}, state, {costCentersSelectedId:action.payload})

        default:
        return state
    
    }

}

export function costCentersTableReady(data) {
    return {
        type: COSTCENTERS_TABLE_READY,
        payload: data
    }
}

export function addEditCostCentersReady(data) {
    return {
        type: ADDEDIT_COSTCENTERS_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function costCentersIdForAction(costCentersId){
    return{
        type:COSTCENTERS_ID_FOR_ACTION,
        payload:costCentersId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Cost Centers/redux/costCenters.js